import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrcamentosEPacotesEditarComponent } from './orcamentos-e-pacotes-editar.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: OrcamentosEPacotesEditarComponent}
  ])],
  exports: [RouterModule]
})
export class OrcamentosEPacotesEditarRoutingModule { }
